:host {
  @include reset-host;

  .wrapper {
    //
  }
}

:host .flora-banner {
  padding: rem(56) $gutter;

  background: $color-flora-light;

  @include mq('max', 'md') {
    padding: rem(40) $gutter-mobile;
  }
}

:host .content {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: $max-width-med;
  margin: 0 auto;

  @include mq('max', 'md') {
    flex-direction: column;
    align-items: flex-start;
  }
}

.logo-wrapper {
  padding-right: 10%;

  @include mq('max', 'md') {
    margin-bottom: rem(24);
    padding: 0;

    img {
      max-width: rem(130);
      height: auto;
    }
  }
}

:host .title {
  margin-bottom: rem(4);

  font-size: $fs-xl;
  line-height: 1.3;
}

:host .bottom-wrapper {
  display: flex;
  flex-direction: column;
  gap: rem(16);
  margin-top: rem(32);

  @include mq('max', 'md') {
    flex-direction: column-reverse;
  }
}

.highlight-block {
  --title-color: #{$white};
  --title-fs: #{$fs-2xl};
  --button-text-color: #{$color-flora-dark};
  --button-bg-color: #{$white};

  display: flex;

  gap: rem(16);
  padding: 36px 24px;

  background: $color-flora;
  border-radius: rem(16);

  @include mq('max', 'lg') {
    flex-wrap: wrap;
  }

  efb-button {
    flex-shrink: 0;
  }
}

:host .usp-list {
  display: flex;
  flex-wrap: wrap;
  gap: rem(16);

  list-style: none;
}

:host .usp-list-item {
  display: flex;
  flex-shrink: 0;
  gap: rem(8);
  align-items: center;
}

:host .check-icon {
  color: $color-flora;
  font-size: rem(16);
}
